import { render, staticRenderFns } from "./AssessmentForm.vue?vue&type=template&id=4cadfab8&scoped=true"
import script from "./AssessmentForm.vue?vue&type=script&lang=ts"
export * from "./AssessmentForm.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentForm.vue?vue&type=style&index=0&id=4cadfab8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cadfab8",
  null
  
)

export default component.exports